import moment from 'moment';

export const Options = {
  paymentTerms: [
    {
      id: 'PREPAID',
      text: 'Prepaid',
    },

    {
      id: 'COLLECT',
      text: 'Collect',
    },
  ],
};
